import React, { ReactNode, useState } from 'react';
import { Box, FormControl, MenuItem, OutlinedInput, Select, SelectChangeEvent, SxProps, Theme } from '@mui/material';

export interface SelectItem {
    name: ReactNode;
    value: string;
    label?: string;
}

interface FormSelectProps {
    label: string;
    value: string;
    items: SelectItem[];
    onChange: (arg: string) => void;
    sx?: SxProps<Theme>;
}

const FormSelect = (props: FormSelectProps) => {
    const [value, setValue] = useState<string>(props.value);

    const handleChange = (event: SelectChangeEvent) => {
        const selectedValue = event.target.value as string;
        setValue(selectedValue);
        props.onChange(selectedValue);
    };

    const selected = props.items.find((i) => i.value === value);

    return (
        <FormControl sx={props.sx} size="small">
            <Select
                value={value}
                onChange={handleChange}
                displayEmpty
                notched={false}
                input={<OutlinedInput label="" notched={false} />}
                renderValue={() => (
                    <Box sx={{ display: "flex", alignItems: "center", height: "100%", lineHeight: 0 }}>
                        {selected?.name}
                    </Box>
                )}
                MenuProps={{
                    PaperProps: {
                        sx: { borderRadius: "12px", mt: 0.5, boxShadow: "0 8px 24px rgba(0,0,0,0.12)" }
                    }
                }}
                sx={{
                    height: 40,
                    borderRadius: "12px",
                    bgcolor: "background.paper",
                    "& .MuiSelect-select": { display: "flex", alignItems: "center", py: 0, lineHeight: 0 },
                    "& fieldset": { borderColor: "grey.300" },
                    "&:hover fieldset": { borderColor: "primary.main !important" },
                    "&.Mui-focused fieldset": { borderColor: "primary.main !important" },
                }}
            >
                {props.items.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 1 }}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FormSelect;
